import script from "./mention-logo-loader.vue?vue&type=script&setup=true&lang=js"
export * from "./mention-logo-loader.vue?vue&type=script&setup=true&lang=js"

import "./mention-logo-loader.vue?vue&type=style&index=0&id=8a731818&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a731818"]])

export default __exports__